import { LinearGradient } from "expo-linear-gradient";
import usePalette from "src/hooks/usePalette";
import { FixedPosition } from "src/styles/position";
import useFooterGradientHeight from "./hooks/useFooterGradientHeight";

const FooterGradient = () => {
	const height = useFooterGradientHeight();
	const { tertiary } = usePalette();

	return (
		<LinearGradient
			pointerEvents="none"
			colors={["transparent", tertiary]}
			style={{
				position: FixedPosition,
				bottom: 0,
				width: "100%",
				height: height,
				pointerEvents: "none",
			}}
		/>
	);
};
export default FooterGradient;
